module.exports = __webpack_public_path__ + "static/media/26UNRWA12.0eeea83c.jpg";